import axios, { AxiosResponse } from "axios";


// Axios instance for default configuration
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Helper for GET request
export const get = async <T>(path: string, params?: object): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosInstance.get(path, {
      params,
    });
    return response.data;
  } catch (error: any) {
    handleError(error);
    throw error.response?.data || error;
  }
};

// Helper for POST request
export const post = async <T>(path: string, body?: object): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosInstance.post(path, body);
    return response.data;
  } catch (error: any) {
    handleError(error);
    throw error.response?.data || error;
  }
};

// Helper for PUT request
export const put = async <T>(path: string, body?: object): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosInstance.put(path, body);
    return response.data;
  } catch (error: any) {
    handleError(error);
    throw error.response?.data || error;
  }
};

// Helper for DELETE request
export const remove = async <T>(path: string, params?: object): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosInstance.delete(path, {
      params,
    });
    return response.data;
  } catch (error: any) {
    handleError(error);
    throw error.response?.data || error;
  }
};

// Error handler function
const handleError = (error: any) => {
  if (error.response) {
    console.error("API Error:", error.response.status, error.response.data);
  } else if (error.request) {
    console.error("No response received:", error.request);
  } else {
    console.error("Error setting up request:", error.message);
  }
};
